import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  signInRequest: ['email', 'password'],
  signInSuccess: ['userInfo', 'accessToken', 'refreshToken'],
  signInFailure: ['error'],
  signInReset: null,

  updateTokens: ['accessToken', 'refreshToken'],

  restorePasswordRequest: ['email'],
  restorePasswordSuccess: null,
  restorePasswordFailure: ['error'],

  restorePasswordWithVerifyRequest: ['email'],
  restorePasswordWithVerifySuccess: null,
  restorePasswordWithVerifyFailure: ['error'],

  verifyMailRestorePasswordRequest: ['data'],
  verifyMailRestorePasswordSuccess: ['hash'],
  verifyMailRestorePasswordFailure: ['error'],

  resetPasswordRequest: ['hash', 'password'],
  resetPasswordSuccess: ['resetPasswordResult'],
  resetPasswordFailure: ['error'],
  resetPasswordReset: null,

  checkEmailHashRequest: ['hash'],
  checkEmailHashSuccess: null,
  checkEmailHashFailure: ['error'],
  checkEmailHashReset: null,

  confirmEmailRequest: ['hash', 'password'],

  checkPasswordHashRequest: ['hash'],
  checkPasswordHashFailure: ['error'],

  checkSocialHashRequest: ['hash'],
  checkSocialHashFailure: ['error'],

  logout: null,

  updateProfile: ['data'],

  signUpRequest: ['data'],
  signUpSuccess: ['userInfo'],
  signUpFailure: ['error'],
  signUpReset: null,

  socialAuthRequest: ['accessToken', 'socialType'],
  socialAuthSuccess: ['userInfo', 'accessToken', 'refreshToken'],
  socialAuthFailure: ['error'],

  resendEmailRequest: ['email'],
  resendEmailFailure: ['error'],

  resendCodeRequest: ['email'],
  resendCodeFailure: ['error'],

  setRemember: ['data'],
  setOnBoardingFinished: ['onBoardingFinished'],
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  userInfo: null,
  accessToken: null,
  refreshToken: null,
  error: null,
  fetching: false,

  checkEmailHashResult: null,

  resetPasswordResult: null,
  resetPasswordError: null,

  isAdmin: false,
  role: null,

  temporaryData: null,

  onBoardingFinished: false,

  rememberMe: null,
})

/* ------------- Selectors ------------- */

export const AuthSelectors = {
  getUserInfo: state => state.auth.userInfo,
  getAccessToken: state => state.auth.accessToken,
  getRefreshToken: state => state.auth.refreshToken,
  getOnBoardingFinished: state => state.auth.onBoardingFinished,
}

/* ------------- Reducers ------------- */

export const restorePasswordRequest = (state, {email}) => {
  return state.merge({fetching: true, error: null})
}

export const restorePasswordSuccess = state => {
  return state.merge({fetching: false, error: null})
}

export const restorePasswordFailure = (state, {error}) => {
  return state.merge({fetching: false, error: error})
}

export const restorePasswordWithVerifyRequest = (state, {email}) => {
  return state.merge({fetching: true, error: null})
}

export const restorePasswordWithVerifySuccess = state => {
  return state.merge({fetching: false, error: null})
}

export const restorePasswordWithVerifyFailure = (state, {error}) => {
  return state.merge({fetching: false, error: error})
}

export const verifyMailRestorePasswordRequest = (state, {data}) => {
  return state.merge({fetching: true, error: null})
}

export const verifyMailRestorePasswordSuccess = (state, {hash}) => {
  return state.merge({fetching: false, error: null})
}

export const verifyMailRestorePasswordFailure = (state, {error}) => {
  return state.merge({fetching: false, error: error})
}

export const resetPasswordRequest = (state, {hash, password}) => {
  return state.merge({fetching: true, resetPasswordError: null})
}

export const resetPasswordSuccess = (state, {resetPasswordResult}) => {
  return state.merge({fetching: false, resetPasswordError: null, resetPasswordResult})
}

export const resetPasswordFailure = (state, {error}) => {
  return state.merge({fetching: false, error: error})
}

export const resetPasswordReset = state => {
  return state.merge({resetPasswordError: null, fetching: false, resetPasswordResult: null})
}

export const signInRequest = (state, {email, password}) => {
  return state.merge({fetching: true, error: null})
}

export const signInSuccess = (state, {userInfo, accessToken, refreshToken}) => {
  const isAdmin = userInfo.role.id === 1,
    role = userInfo.role.id,
    onBoardingFinished = !!userInfo.payment_method
  let newUserInfo = {}
  if (!userInfo?.subscription) {
    newUserInfo = {
      ...state?.userInfo,
      ...userInfo,
      subscription: {id: 1, name: 'Free', description: 'Ideal for New Digital Marketers', price: 0, subscribed_monthly: true},
    }
  } else {
    newUserInfo = {...state?.userInfo, ...userInfo}
  }

  return state.merge({fetching: false, error: null, userInfo: newUserInfo, accessToken, refreshToken, isAdmin, role, onBoardingFinished})

  //return state.merge({ fetching: false, error:null, userInfo , accessToken, refreshToken, isAdmin, role, onBoardingFinished })
}

export const signInFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const signInReset = state => {
  return state.merge({error: null, fetching: false})
}

export const updateTokens = (state, {accessToken, refreshToken}) => {
  return state.merge({accessToken, refreshToken})
}

export const checkEmailHashRequest = (state, {hash}) => {
  return state.merge({fetching: true, error: null})
}

export const checkEmailHashSuccess = state => {
  return state.merge({fetching: false, error: null, checkEmailHashResult: true})
}

export const checkEmailHashFailure = (state, {error}) => {
  return state.merge({error, fetching: false, checkEmailHashResult: null})
}

export const checkEmailHashReset = state => {
  return state.merge({fetching: false, error: null, checkEmailHashResult: null})
}

export const confirmEmailRequest = (state, {hash, password}) => {
  return state.merge({fetching: true, error: null, temporaryData: null})
}

export const checkPasswordHashRequest = (state, {hash}) => {
  return state.merge({fetching: true, error: null})
}

export const checkPasswordHashFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const checkSocialHashRequest = (state, {hash}) => {
  return state.merge({fetching: true, error: null})
}

export const checkSocialHashFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const logout = state => {
  return state.merge({...INITIAL_STATE, rememberMe: state.rememberMe})
}

export const updateProfile = (state, {data}) => {
  let userInfo = {}

  if (!data?.subscription) {
    if (state?.userInfo?.subscription?.name !== 'Free') {
      userInfo = {...state.userInfo, ...data}
    } else {
      userInfo = {
        ...state.userInfo,
        ...data,
        subscription: {id: 1, name: 'Free', description: 'Ideal for New Digital Marketers', price: 0, subscribed_monthly: true},
      }
    }
  } else {
    userInfo = {...state.userInfo, ...data}
  }
  return state.merge({userInfo})
}

export const signUpRequest = (state, {data}) => {
  return state.merge({fetching: true, error: null})
}

export const signUpSuccess = (state, {userInfo}) => {
  return state.merge({fetching: false, error: null, temporaryData: {...userInfo}})
}

export const signUpFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const signUpReset = state => {
  return state.merge({error: null, fetching: false, temporaryData: null})
}

export const socialAuthRequest = (state, {accessToken, socialType}) => {
  return state.merge({fetching: true, error: null})
}

export const socialAuthSuccess = (state, {userInfo, accessToken, refreshToken}) => {
  const isAdmin = userInfo.role.id === 1,
    role = userInfo.role.id
  return state.merge({fetching: false, error: null, userInfo, accessToken, refreshToken, isAdmin, role})
}

export const socialAuthFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const resendEmailRequest = (state, {email}) => {
  return state.merge({fetching: true, error: null})
}

export const resendEmailFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const resendCodeRequest = (state, {email}) => {
  return state.merge({fetching: true, error: null})
}

export const resendCodeFailure = (state, {error}) => {
  return state.merge({error, fetching: false})
}

export const setRemember = (state, {data}) => {
  return state.merge({rememberMe: data})
}

export const setOnBoardingFinished = (state, {onBoardingFinished}) => {
  return state.merge({onBoardingFinished})
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SIGN_IN_REQUEST]: signInRequest,
  [Types.SIGN_IN_SUCCESS]: signInSuccess,
  [Types.SIGN_IN_FAILURE]: signInFailure,
  [Types.SIGN_IN_RESET]: signInReset,

  [Types.UPDATE_TOKENS]: updateTokens,

  [Types.CHECK_EMAIL_HASH_REQUEST]: checkEmailHashRequest,
  [Types.CHECK_EMAIL_HASH_SUCCESS]: checkEmailHashSuccess,
  [Types.CHECK_EMAIL_HASH_FAILURE]: checkEmailHashFailure,
  [Types.CHECK_EMAIL_HASH_RESET]: checkEmailHashReset,

  [Types.CONFIRM_EMAIL_REQUEST]: confirmEmailRequest,

  [Types.RESTORE_PASSWORD_REQUEST]: restorePasswordRequest,
  [Types.RESTORE_PASSWORD_SUCCESS]: restorePasswordSuccess,
  [Types.RESTORE_PASSWORD_FAILURE]: restorePasswordFailure,

  [Types.RESTORE_PASSWORD_WITH_VERIFY_REQUEST]: restorePasswordWithVerifyRequest,
  [Types.RESTORE_PASSWORD_WITH_VERIFY_SUCCESS]: restorePasswordWithVerifySuccess,
  [Types.RESTORE_PASSWORD_WITH_VERIFY_FAILURE]: restorePasswordWithVerifyFailure,

  [Types.VERIFY_MAIL_RESTORE_PASSWORD_REQUEST]: verifyMailRestorePasswordRequest,
  [Types.VERIFY_MAIL_RESTORE_PASSWORD_SUCCESS]: verifyMailRestorePasswordSuccess,
  [Types.VERIFY_MAIL_RESTORE_PASSWORD_FAILURE]: verifyMailRestorePasswordFailure,

  [Types.RESET_PASSWORD_REQUEST]: resetPasswordRequest,
  [Types.RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
  [Types.RESET_PASSWORD_FAILURE]: resetPasswordFailure,
  [Types.RESET_PASSWORD_RESET]: resetPasswordReset,

  [Types.CHECK_PASSWORD_HASH_REQUEST]: checkPasswordHashRequest,
  [Types.CHECK_PASSWORD_HASH_FAILURE]: checkPasswordHashFailure,

  [Types.CHECK_SOCIAL_HASH_REQUEST]: checkSocialHashRequest,
  [Types.CHECK_SOCIAL_HASH_FAILURE]: checkSocialHashFailure,

  [Types.LOGOUT]: logout,

  [Types.UPDATE_PROFILE]: updateProfile,

  [Types.SIGN_UP_REQUEST]: signUpRequest,
  [Types.SIGN_UP_SUCCESS]: signUpSuccess,
  [Types.SIGN_UP_FAILURE]: signUpFailure,
  [Types.SIGN_UP_RESET]: signUpReset,

  [Types.SOCIAL_AUTH_REQUEST]: socialAuthRequest,
  [Types.SOCIAL_AUTH_SUCCESS]: socialAuthSuccess,
  [Types.SOCIAL_AUTH_FAILURE]: socialAuthFailure,

  [Types.RESEND_EMAIL_REQUEST]: resendEmailRequest,
  [Types.RESEND_EMAIL_FAILURE]: resendEmailFailure,

  [Types.RESEND_CODE_REQUEST]: resendCodeRequest,
  [Types.RESEND_CODE_FAILURE]: resendCodeFailure,

  [Types.SET_REMEMBER]: setRemember,
  [Types.SET_ON_BOARDING_FINISHED]: setOnBoardingFinished,
})
